<div class="container-fluid manage-quota-container">
    @if (loadingStatus.loadingQuotaDetails){
    <div class="d-flex justify-content-center pt-5">
        <zint-loader></zint-loader>
    </div>
    }
    @else {
        <div class="container">
            <h1 class="mb-2">Manage {{quotaType}} Quota</h1>
    
            @if(isParentOrgSuperUser && organisationQuotaDetails){  
                <div class="zint-base-card zint-card-white mb-4">
                    <div class="d-flex justify-content-between border-bottom pb-4">
                        <h4 class="text-all-caps mb-0">{{organisationQuotaDetails.organisation_name}}</h4>
                        <button class="rounded-btn-base rounded-btn-light btn-p-sm" [matMenuTriggerFor]="confirmEqualOrgDistro" #quotaMenuTrigger="matMenuTrigger"><i class="fal fa-maximize mr-1"></i> Equally Distribute Quota Across All Teams and Users</button>
                        <mat-menu #confirmEqualOrgDistro="matMenu" class="quota-menu" xPosition="before" yPosition="below">
                            <button class="rounded-btn-base rounded-btn-vivid-outline btn-p-xs d-block mx-auto" (click)="equallyDistributeQuotas()">Confirm</button>
                        </mat-menu>
                    </div>
                    <div class="d-flex justify-content-around pt-4">
                        <div class="d-flex flex-column">
                            <span><i class="fal fa-grid-2 fa-md text-primary"></i></span>
                            <h4 class="mt-2 mb-0 text-bold-600">{{organisationQuotaDetails.organisation_quota}}</h4>
                            <span>Total Allowance</span>
                        </div>
                        <div class="d-flex flex-column">
                            <span><i class="fal fa-share fa-md text-warning"></i></span>
                            <h4 class="mt-2 mb-0 text-bold-600">{{orgQuotaAllocated()}}</h4>
                            <span>Allocated</span>
                        </div>
                        <div class="d-flex flex-column">
                            <span><i class="fal fa-box-archive fa-md text-success"></i></span>
                            <h4 class="mt-2 mb-0 text-bold-600">{{orgRemainingQuota()}}</h4>
                            <span>Remaining</span>
                        </div>
                    </div>
                </div>
    
                <mat-accordion>
                    @for (team of organisationQuotaDetails.teams; track $index) {
                        <mat-expansion-panel hideToggle (opened)="getTeamDetails(team.id)" #panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title><h5 class="mb-0 text-grey-800">{{team.name}}</h5></mat-panel-title>                                
                                
                                <span>Credits Allocated: {{teamQuotaInput?.value || team.quota}}</span>
                            </mat-expansion-panel-header>
                                               

                            <div class="pt-2">
                                @if (loadingStatus.loadingTeamQuotaDetails){
                                    <div class="d-flex justify-content-center">
                                        <zint-loader size="xSmall"></zint-loader>
                                    </div>
                                }                                
                                @if (teamQuotaDetails){
                                    
                                    <div class="zint-base-card d-flex flex-column">
                                        <button [matMenuTriggerFor]="setTeamQuotaMenu" #quotaMenuTrigger="matMenuTrigger"
                                            class="rounded-btn-base rounded-btn-dark-hover align-self-end">
                                            + Set Quota
                                        </button>
                                        <mat-menu #setTeamQuotaMenu="matMenu" class="quota-menu" xPosition="before" yPosition="below">
                                            <div role="menu" mat-menu-item (click)="$event.stopPropagation()">
                                                <h5 class="mb-0">Set Team Quota</h5>
                                                <hr>
                                                <span class="d-block text-grey-600">Unallocated Quota Left: <strong
                                                        class="ml-4">{{orgRemainingQuota()}}</strong>
                                                </span>
                                                <input #teamQuotaInput type="number" class="rounded-input-base full-width my-2" [value]="team.quota" min="0"
                                                    [max]="organisationQuotaDetails.organisation_quota"
                                                    (keyup.enter)="setTeamQuota(team.id, teamQuotaInput.value, teamQuotaDetails?.team_quota);  quotaMenuTrigger.closeMenu();">
                                                <button class="rounded-btn-base rounded-btn-light btn-p-xs d-block mr-0 ml-auto"
                                                    (click)="setTeamQuota(team.id, teamQuotaInput.value, teamQuotaDetails?.team_quota); quotaMenuTrigger.closeMenu();">Set Team Quota
                                                </button>
                                            </div>
                                        </mat-menu>
                                        <span class="align-self-start">Team quota assigned: {{teamQuotaDetails.currentTeamTotal}}</span>
                                        <mat-progress-bar mode="determinate" [value]="getProgressBarValue(teamQuotaDetails.currentTeamTotal, teamQuotaDetails.team_quota)" class=""></mat-progress-bar>
                                        <span class="align-self-end">Total: {{teamQuotaDetails.team_quota}}</span>

                                    </div>
                                    <details class="mt-4">
                                        <summary><span class="text-bold-600 text-grey-600"><u>View Team Members Allocation</u></span>
                                        </summary>
                                        
                                            <div class="zint-rounded-table-container">
                                                <table class="table table-layout-fixed zint-rounded-table">
                                                    <thead style="background: var(--zint-grey-300);">
                                                        <tr>
                                                            <th scope="col">Email</th>
                                                            <th scope="col" class="text-right"> Quota Assigned</th>
                                                            <!-- <th scope="col" class="text-right" style="">Quota Used</th> -->
                                                            <th scope="col">Update Quota</th>
                                                            <th scope="col"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        @for (user of teamQuotaDetails.users; track $index){
                                                            <tr>  
                                                                <td class="vertical-baseline">{{user.email}}</td>
                                                                <td class="vertical-baseline text-right">{{user.quota}}</td>
                                                                <!-- <td class="vertical-baseline text-right">user.quota_used</td> -->
                                                                <td class="vertical-baseline">
                                                                    <input #userQuotaInput 
                                                                    type="number" class="rounded-input-base full-width" 
                                                                    [placeholder]="user.quota" 
                                                                    min="0" [max]="team.quota"
                                                                    (keyup.enter)="setUserQuota(user.id, userQuotaInput.value, team.id)">
                                                                </td>
                                                                <td class="vertical-baseline">
                                                                    <button class="rounded-btn-base rounded-btn-light btn-p-xs small" (click)="setUserQuota(user.id, userQuotaInput.value, team.id)">Update
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            
                                                        }
                                                        </tbody>
                                                </table>
                                            </div>
                                    </details>
                                }
                            </div>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            }
    
            @if(!isParentOrgSuperUser && isSuperUser && teamQuotaDetails){
                <div class="d-flex justify-content-between mt-5 mb-2">
                    <h3 class="mb-0">{{teamQuotaDetails.team_name}}</h3>
                    <h4 class="mb-0">Credits Allocated: {{teamQuotaDetails.team_quota}}</h4>
                </div>   

                <div class="zint-base-card">                    
                <div class="zint-base-card zint-card-white d-flex flex-column mb-3">                    
                    <span class="align-self-start">Team quota assigned: {{teamQuotaDetails.currentTeamTotal}}</span>
                    <mat-progress-bar mode="determinate"
                        [value]="getProgressBarValue(teamQuotaDetails.currentTeamTotal, teamQuotaDetails.team_quota)"
                        class=""></mat-progress-bar>
                    <span class="align-self-end">Total: {{teamQuotaDetails.team_quota}}</span>
                </div>
                <div class="zint-rounded-table-container">
                        <table class="table table-layout-fixed zint-rounded-table">
                            <thead style="background: var(--zint-grey-300);">
                                <tr>
                                    <th scope="col">Email</th>
                                    <th scope="col" class="text-right"> Quota Assigned</th>
                                    <!-- <th scope="col" class="text-right" style="">Quota Used</th> -->
                                    <th scope="col">Update Quota</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (user of teamQuotaDetails.users; track $index){
                                <tr>
                                    <td class="vertical-baseline">{{user.email}}</td>
                                    <td class="vertical-baseline text-right">{{user.quota}}</td>
                                    <!-- <td class="vertical-baseline text-right">{{user.quota_used}}</td> -->
                                    <td class="vertical-baseline">
                                        <input #userQuotaInput type="number" class="rounded-input-base full-width"
                                            [placeholder]="user.quota" min="0"
                                            (keyup.enter)="setUserQuota(user.id, userQuotaInput.value)">
                                    </td>
                                    <td class="vertical-baseline">
                                        <button class="rounded-btn-base rounded-btn-light btn-p-xs small"
                                            (click)="setUserQuota(user.id, userQuotaInput.value, team.id)">Update
                                        </button>
                                    </td>
                                </tr>
                    
                                }
                            </tbody>
                        </table>
                </div>
                </div>
            }
        </div>
    }
    

</div>
